import React from "react";
import Colors from "../../Constant/Colors";
import Search from "../Icons/Search";
import { Container, SearchInput } from "./styles";

const SearchBar = ({style, search, handleSearch, placeholder }) => {
  return (
    <Container style={style}>
      <Search />
      <SearchInput
        className="form-control"
        placeholder={placeholder ?? "Search.."}
        value={search}
        onChange={(e) => handleSearch(e.target.value)}
        style={{ fontSize: 14, color: Colors.lightTxt }}
      />
    </Container>
  );
};

export default SearchBar;
